/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/validate.js');

export function contactForm() {

  $('input').on('focus', function () {
    $(this)
      .parent()
      .addClass('focused');
  });

  $('input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .removeClass('focused');
    }
  });

  $('textarea').on('focus', function () {
    $(this)
      .parent()
      .addClass('focused');
  });

  $('textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .parent()
        .removeClass('focused');
    }
  });

  // Validation
  var contactForm = $('#contact_form');
  contactForm.validate({
    submitHandler: function (contactForm) {
      contactForm.submit();
      // grecaptcha.reset();
      // grecaptcha.execute();
    },
    rules: {
      // "name": 'first-name',
      // "comment": 'required',
      "contact[email]": {
        required: true,
        email: true
      }
    },
    messages: {
      // "name": "Please, enter your first name.",
      // "comment": "Please, let us know how we can help.",
      "contact[email]": "Please, enter a valid email address."
    }
  });
}
